module.exports = __webpack_public_path__ + "static/media/btc-qr.d86fa729.png";